<template>
    <div class="leaderboard-wrapper">
        <div class="leaderboard">
            <Adsense data-ad-format="horizontal" data-ad-client="ca-pub-9822209171586486" data-ad-slot="5964623418"> </Adsense>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdLeaderboard'
}
</script>

<style scoped>
.leaderboard-wrapper {
    width: 100%;
    text-align: center;
}
.leaderboard {
    width: 90%;
    display: inline-block;
}

@media (min-width: 768px) {
    .leaderboard {
        width: 70%;
    }
}

@media (min-width: 1200px) {
    .leaderboard-wrapper {
        height: 90px;
    }
    .leaderboard {
        width: 728px;
        height: 90px;
    }
}
</style>
